<template>
  <generic-modal :title="$t('trickshot')" ref="generic_modal" :is_wide="false">
    <form>
      <div class="columns">
        <div class="column is-one-third">
          <div class="field">
            <label class="label">{{ $t("date of magic") }}</label>
            <generic-calendar
              type="date"
              display_mode="dialog"
              ref="date_calendar"
              @selected="date_changed"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("player") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.player" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("place") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.place" />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="container">
          <div class="playground">
            <canvas
              ref="signature_pad"
              class="signature-pad"
              width="522"
              height="270"
            ></canvas>
            <!-- <img
              src="https://upload.wikimedia.org/wikipedia/commons/5/5e/American-style_pool_table_diagram_%28empty%29.png"
              alt=""
            /> -->
            <div class="yellow ball" id="ball_1"></div>
            <div style="background-color: blue" class="ball" id="ball_2"></div>
            <div style="background-color: red" class="ball" id="ball_3"></div>
            <div
              style="background-color: purple"
              class="ball"
              id="ball_4"
            ></div>
            <div
              style="background-color: orange"
              class="ball"
              id="ball_5"
            ></div>
            <div style="background-color: green" class="ball" id="ball_6"></div>
            <div
              style="background-color: maroon"
              class="ball"
              id="ball_7"
            ></div>
            <div
              style="background-color: black; border: 1px solid white"
              class="ball"
              id="ball_8"
            ></div>
            <div style="background-color: yellow" class="ball" id="ball_9">
              <div class="stripe"></div>
            </div>
            <div style="background-color: blue" class="ball" id="ball_10">
              <div class="stripe"></div>
            </div>
            <div style="background-color: red" class="ball" id="ball_11">
              <div class="stripe"></div>
            </div>
            <div style="background-color: purple" class="ball" id="ball_12">
              <div class="stripe"></div>
            </div>
            <div style="background-color: orange" class="ball" id="ball_13">
              <div class="stripe"></div>
            </div>
            <div style="background-color: green" class="ball" id="ball_14">
              <div class="stripe"></div>
            </div>
            <div style="background-color: maroon" class="ball" id="ball_15">
              <div class="stripe"></div>
            </div>
            <div style="background-color: white" class="ball" id="ball_0"></div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        :disabled="is_form_invalid"
        @click="save"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
      <button class="button is-rounded" @click="clear">
        <span class="icon">
          <i class="fa fa-eraser"></i>
        </span>
        <span>{{ $t("clear") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  system_settings,
} from "@/utils";
import moment from "moment";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import SignaturePad from "signature_pad";

export default {
  name: "TrickshotModal",
  components: { GenericModal, GenericCalendar },
  data() {
    return {
      system_settings,
      signature_pad_instance: null,
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.date || !v.meta.player;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(trickshot_uuid) {
      let v = this;
      v.set_initial_state();

      if (trickshot_uuid) {
        get("/trickshot", { uuid: trickshot_uuid })
          .then((trickshot) => {
            v.meta = trickshot;
            v.$refs.generic_modal.show_modal();
            if (trickshot && trickshot.date)
              v.$refs.date_calendar.set_date(trickshot.date);
            if (
              trickshot &&
              trickshot.settings &&
              trickshot.settings.hand_traced
            )
              v.signature_pad_instance.fromDataURL(
                trickshot.settings.hand_traced
              );
            if (trickshot && trickshot.settings && trickshot.settings.balls) {
              for (let i = 0; i < 16; i++) {
                let elmnt = document.getElementById("ball_" + i);
                elmnt.style.top = trickshot.settings.balls[`ball_${i}`].top;
                elmnt.style.left = trickshot.settings.balls[`ball_${i}`].left;
              }
            }
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      v.meta.settings.hand_traced = v.signature_pad_instance.toDataURL();
      for (let i = 0; i < 16; i++) {
        let elmnt = document.getElementById("ball_" + i);
        if (!v.meta.settings.balls) v.meta.settings.balls = {};
        v.meta.settings.balls[`ball_${i}`] = {
          top: elmnt.style.top,
          left: elmnt.style.left,
        };
      }
      if (!v.meta.uuid)
        put("/trickshot", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/trickshot", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        date: "",
        player: "",
        place: "",
        settings: {},
      };
      v.error = "";
      v.signature_pad_instance.clear();
      v.$refs.date_calendar.clear();

      for (let i = 0; i < 16; i++) {
        let elmnt = document.getElementById("ball_" + i);
        elmnt.style.top = `0px`;
        elmnt.style.left = `${i * 30 + 40}px`;
        v.make_draggable(elmnt);
      }
    },
    date_changed(date) {
      let v = this;
      v.meta.date = moment(
        date,
        v.system_settings.enterprise_settings.date_format
      );
    },
    make_draggable(elmnt) {
      var pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;

      elmnt.onmousedown = dragMouseDown;

      function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        elmnt.style.top = elmnt.offsetTop - pos2 + "px";
        elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
      }

      function closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
      }
    },
    clear() {
      let v = this;
      v.signature_pad_instance.clear();
    },
  },
  mounted() {
    let v = this;

    for (let i = 0; i < 16; i++) {
      let elmnt = document.getElementById("ball_" + i);
      elmnt.style.left = `${i * 30 + 20}px`;
      v.make_draggable(elmnt);
    }

    var signaturePad = new SignaturePad(v.$refs.signature_pad, {
      backgroundColor: "rgba(255, 255, 255, 0)",
      penColor: "rgb(0, 0, 0)",
    });
    v.signature_pad_instance = signaturePad;
  },
  watch: {},
};
</script>
<style scoped>
.ball {
  border: 1px solid black;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  position: absolute;
  z-index: 9;
}

.ball > .stripe {
  width: 12px;
  height: 12px;
  border: 1px solid black;
  border-radius: 100%;
  background-color: white;
  margin-left: 5px;
  display: block;
  padding-bottom: 5px;
}

.playground {
  width: 100%;
  height: 315px;
  /* border: 1px solid red; */
  background: url("https://upload.wikimedia.org/wikipedia/commons/5/5e/American-style_pool_table_diagram_%28empty%29.png");
  background-size: cover;
}

.container {
  height: 315px;
}

.signature-pad {
  /* border: 1px solid greenyellow; */
  margin-top: 20px;
  margin-left: 20px;
}

.yellow.ball {
  background-color: yellow !important;
}
</style>
